/*
 * Ce script JavaScript gère l'interaction sur une collection d'articles.
 * Quand on clique sur un article, celui-ci devient l'article actif. Les fonctionnalités offertes sont :
 * - L'ajout de la classe 'active' à l'article cliqué.
 * - La suppression de la classe 'active' des autres articles.
 */

// Sélection du conteneur du slider et de tous les articles qu'il contient
const realisationsImagesSliderContainer = document.querySelector(
  ".realisations-images-slider-container"
);
const articles = realisationsImagesSliderContainer.querySelectorAll("article");

// Parcours de chaque article
for (let i = 0; i < articles.length; i++) {
  // Ajout d'un écouteur d'événement 'click' à chaque article
  articles[i].addEventListener("click", () => {
    // Lorsque l'article est cliqué, retirez 'active' de tous les articles
    for (let j = 0; j < articles.length; j++) {
      articles[j].classList.remove("active");
    }

    // Ajouter 'active' à l'article cliqué
    articles[i].classList.add("active");
  });
}
